export default __webpack_public_path__ + "static/media/blocks.ab55677a.webp";